import { map } from 'lodash';
import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import {
  MailchimpAccount,
  MailchimpModel,
  MailchimpList,
  MailchimpListMergeField,
} from '../model/MailchimpModel';
import MailchimpCRUDActions from '../actions/MailchimpCRUDActions';

type ActionType = {
  type: string;
  accounts: MailchimpAccount[];
  accountsId: number[];
  lists: MailchimpList[];
  totalListItems: number;
  listMergeFields: MailchimpListMergeField[];
};

const initialState: MailchimpModel = {
  busy: false,
  accounts: [],
  accountsId: [],
  lists: [],
  totalListItems: 0,
  listMergeFields: [],
};

export const mailchimp = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case MailchimpCRUDActions.busyAction:
      return setBusy(state);
    case MailchimpCRUDActions.retrieveOauthUrlAction: {
      return {
        ...state,
        busy: false,
      };
    }
    case MailchimpCRUDActions.retrieveAccounts: {
      return {
        ...state,
        accounts: action.accounts,
        accountsId: map(action.accounts, 'id'),
        busy: false,
      };
    }
    case MailchimpCRUDActions.retrieveLists: {
      return {
        ...state,
        lists: action.lists,
        totalListItems: action.totalListItems,
        busy: false,
      };
    }
    case MailchimpCRUDActions.retrieveMoreLists: {
      return {
        ...state,
        lists: [...state.lists, ...action.lists],
        totalListItems: action.totalListItems,
        busy: false,
      };
    }
    case MailchimpCRUDActions.retrieveListMergeFields: {
      return {
        ...state,
        listMergeFields: action.listMergeFields,
        busy: false,
      };
    }
    case MailchimpCRUDActions.revokeAccess: {
      return {
        ...state,
        busy: false,
      };
    }
    case MailchimpCRUDActions.resetStore: {
      return initialState;
    }
    case MailchimpCRUDActions.resetListMergeFieldsAction: {
      return {
        ...state,
        listMergeFields: [],
      };
    }
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
